"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
const layout_1 = require("../../../theme/layout");
exports.Wrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${layout_1.CORNER_RADIUS_SMALL};
  width: ${({ $width }) => ($width ? `${$width}px` : `24px`)};
  height: ${({ $height }) => ($height ? `${$height}px` : `24px`)};

  ${({ $hoverEffect }) => $hoverEffect &&
    (0, styled_components_1.css) `
      &:hover {
        cursor: pointer;
        background-color: ${colors_1.PALE_GREEN};
      }
      &:active {
        background-color: ${colors_1.DARK_GREEN};
        & > svg path {
          fill: ${colors_1.WHITE};
        }
      }
    `}
`;
//# sourceMappingURL=IconWrapper.styles.js.map